module.exports = __webpack_public_path__ + "img/favicon-mio-curriculum.e03859a6.svg";